export const contest = {
    contestDetailsTabs : {
        default: ['home', 'lessons', 'manage', 'ranking']
    }
}